var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgGradientWhiteLightBulb = function SvgGradientWhiteLightBulb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.781,
    y: 14.651,
    width: 4.437,
    height: 1.21,
    rx: 0.469,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.847 6.871a.405.405 0 0 1 .088-.44l2.384-2.384a.405.405 0 1 1 .572.572L6.198 6.312H8.64a.405.405 0 0 1 .286.69L6.542 9.388a.405.405 0 0 1-.572-.573l1.693-1.693H5.221a.405.405 0 0 1-.374-.25Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.623 12.906A6.657 6.657 0 0 0 7 .133 6.655 6.655 0 0 0 4.38 12.906v1.249c0 .052.042.094.094.094h5.056a.094.094 0 0 0 .094-.094v-1.248ZM4.848 6.873a.405.405 0 0 1 .088-.44L7.32 4.047a.405.405 0 1 1 .572.572L6.199 6.314H8.64a.405.405 0 0 1 .286.69L6.543 9.388a.405.405 0 1 1-.572-.572l1.693-1.693H5.222a.405.405 0 0 1-.374-.25Z",
    fill: "url(#gradient-white-light-bulb_svg__a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient-white-light-bulb_svg__a",
    x1: 7.001,
    y1: 0.132,
    x2: 7.002,
    y2: 19.186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0
  })))));
};

export default SvgGradientWhiteLightBulb;